import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { actionApi } from '../utils/actionApi';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const { actionToken } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // دریافت تعداد اعلان‌های خوانده نشده
  const fetchUnreadCount = useCallback(async () => {
    // بررسی مستقیم از localStorage برای اطمینان
    const tokenFromStorage = localStorage.getItem('actionToken');
    if (!actionToken || !tokenFromStorage) {
      setUnreadCount(0);
      return;
    }

    try {
      const res = await actionApi.getUnreadCount();
      setUnreadCount(res?.data?.unread_count || 0);
    } catch (error) {
      console.error('Load unread count error:', error);
      setUnreadCount(0);
    } finally {
      setLoading(false);
    }
  }, [actionToken]);

  // بارگذاری اولیه
  useEffect(() => {
    // بررسی مستقیم از localStorage برای اطمینان
    const tokenFromStorage = localStorage.getItem('actionToken');
    if (actionToken && tokenFromStorage) {
      setLoading(true);
      fetchUnreadCount();
    } else {
      setUnreadCount(0);
    }
  }, [actionToken, fetchUnreadCount]);

  // به‌روزرسانی خودکار هر 30 ثانیه
  useEffect(() => {
    // بررسی مستقیم از localStorage برای اطمینان
    const tokenFromStorage = localStorage.getItem('actionToken');
    if (!actionToken || !tokenFromStorage) return;

    const interval = setInterval(() => {
      // بررسی مجدد در هر interval
      const currentToken = localStorage.getItem('actionToken');
      if (!currentToken) {
        setUnreadCount(0);
        return;
      }
      fetchUnreadCount();
    }, 30000); // هر 30 ثانیه

    return () => clearInterval(interval);
  }, [actionToken, fetchUnreadCount]);

  // تابع برای به‌روزرسانی دستی
  const refreshUnreadCount = useCallback(() => {
    // بررسی مستقیم از localStorage برای اطمینان
    const tokenFromStorage = localStorage.getItem('actionToken');
    if (actionToken && tokenFromStorage) {
      fetchUnreadCount();
    }
  }, [actionToken, fetchUnreadCount]);

  return (
    <NotificationContext.Provider
      value={{
        unreadCount,
        loading,
        refreshUnreadCount,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;

